// Mock data for JENMA Concept

export const portfolioProjects = [
  {
    id: 13,
    title: "Dressing Noyer & Lumière",
    category: "Dressing",
    description: "Suite parentale avec dressing ouvert en noyer, penderies éclairées par LED, tiroirs gris perle et tête de lit monumentale formant cloison.",
    image: "https://customer-assets-agu9un31.emergentagent.net/job_precision-agencement/artifacts/d96e68e233e76bde_image.png",
    year: "2026",
    configurator: "dressing"
  },
  {
    id: 1,
    title: "Cuisine Contemporaine",
    category: "Résidentiel",
    description: "Îlot central en marbre veiné, meubles gris mat et niches éclairées avec étagères en verre.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/3eoicako_1000071242.jpg",
    year: "2024",
    configurator: "cuisine"
  },
  {
    id: 2,
    title: "Loft Urbain",
    category: "Résidentiel",
    description: "Rénovation complète d'un espace industriel en loft moderne et élégant.",
    image: "https://images.pexels.com/photos/3754595/pexels-photo-3754595.jpeg",
    year: "2024"
  },
  {
    id: 3,
    title: "Bureau Exécutif",
    category: "Professionnel",
    description: "Conception d'espaces de travail alliant fonctionnalité et esthétique raffinée.",
    image: "https://images.unsplash.com/photo-1641998148499-cb6b55a3c0d3",
    year: "2023",
    configurator: "bureau"
  },
  {
    id: 4,
    title: "Salle de Bain Balinaise",
    category: "Résidentiel",
    description: "Ambiance spa avec cascade naturelle, matériaux bruts et receveur de douche en pierre naturelle.",
    image: "/bathroom-balinese.webp",
    year: "2024",
    configurator: "sdb"
  },
  {
    id: 5,
    title: "Spa Zen Douche Pluie",
    category: "Résidentiel",
    description: "Douche cascade à effet pluie, pierres naturelles dorées, éclairage indirect chaleureux et végétation tropicale.",
    image: "/bathroom-rain-shower.webp",
    year: "2024",
    configurator: "sdb"
  },
  {
    id: 6,
    title: "Buanderie Scandinave",
    category: "Résidentiel",
    description: "Espace fonctionnel optimisé avec rangements en bois, paniers naturels et plan de travail sur-mesure.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/sk71a9qw_Screenshot_20260422_204300_com_google_android_apps_photos_SearchActivity.jpg",
    year: "2024",
    configurator: "buanderie"
  },
  {
    id: 7,
    title: "Living Bar & Cave",
    category: "Résidentiel",
    description: "Coin bar haut de gamme avec cave à vin intégrée, machine espresso et rangements éclairés en bois naturel.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/h1p6sqqx_Screenshot_20260422_205451_com_hihonor_photos_GalleryMain.jpg",
    year: "2024",
    configurator: "bar"
  },
  {
    id: 8,
    title: "Terrasse Lounge Tropicale",
    category: "Extérieur",
    description: "Pergola bois avec éclairage LED, salon de jardin luxueux, deck en bois et végétation paysagère nocturne.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/8frlg08o_1000071251.jpg",
    year: "2024",
    configurator: "exterieur"
  },
  {
    id: 9,
    title: "Cuisine Extérieure Pro",
    category: "Extérieur",
    description: "Bar extérieur avec barbecue, toiture tuiles méditerranéennes et table haute design créatif.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/76zpcc56_1000071249.jpg",
    year: "2024",
    configurator: "exterieur"
  },
  {
    id: 10,
    title: "Espace Fire Pit Zen",
    category: "Extérieur",
    description: "Bancs design bois/béton, fire pit circulaire en pierre et aménagement paysager minimaliste.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/klezaix0_1000071244.jpg",
    year: "2024",
    configurator: "exterieur"
  },
  {
    id: 11,
    title: "Cuisine Marbre & Verre",
    category: "Résidentiel",
    description: "Design épuré avec armoire vitrée éclairée, îlot marbre sculpté et parquet chevron.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/uug8c6vt_1000071241.jpg",
    year: "2024",
    configurator: "cuisine"
  },
  {
    id: 12,
    title: "Cuisine Arborescente",
    category: "Résidentiel",
    description: "Architecture organique spectaculaire avec arbre sculpté intégré, ouvertures naturelles et fusion totale intérieur/extérieur.",
    image: "https://customer-assets.emergentagent.com/job_precision-agencement/artifacts/qvssjjtu_1000071252.jpg",
    year: "2024",
    configurator: "cuisine"
  }
];

export const expertiseServices = [
  {
    id: 1,
    title: "Conseil en Agencement",
    icon: "Compass",
    description: "Analyse de vos espaces et conseils personnalisés pour optimiser chaque mètre carré avec précision et style.",
    features: ["Audit d'espace", "Plans d'optimisation", "Sélection matériaux"]
  },
  {
    id: 2,
    title: "Dessin Technique",
    icon: "Ruler",
    description: "Plans techniques détaillés au millimètre près, respectant les normes professionnelles les plus strictes.",
    features: ["Plans 2D détaillés", "Cotations précises", "Documentations techniques"]
  },
  {
    id: 3,
    title: "Suivi & Modélisation 3D",
    icon: "Box",
    description: "Visualisation réaliste de votre projet et suivi complet de sa réalisation jusqu'à la livraison finale.",
    features: ["Rendus 3D photoréalistes", "Suivi de chantier", "Coordination artisans"]
  }
];

export const projectTypes = [
  { value: "residentiel", label: "Résidentiel" },
  { value: "professionnel", label: "Professionnel" },
  { value: "conseil", label: "Conseil uniquement" }
];

export const contactFormSubmit = (formData) => {
  // Mock API call - will be replaced with real backend
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("Form submitted:", formData);
      resolve({ success: true, message: "Message envoyé avec succès!" });
    }, 1000);
  });
};
